var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-contacts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons---\\u2660\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-contacts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(8.000000, 9.000000)",
    fillRule: "nonzero",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,24 C14.386,24 12.893,23.354 11.573,22.291 C7.436,22.83 3.532,24.111 0,25.998 L0,30 L32,30 L32,25.998 C28.468,24.111 24.564,22.831 20.427,22.291 C19.107,23.354 17.614,24 16,24 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C11,0 8,4 8,9 C8,15.075 11.582,22 16,22 C20.418,22 24,15.075 24,9 C24,4 21,0 16,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 1.000000)",
    stroke: "#FF6666",
    strokeWidth: 2,
    strokeDasharray: "2,3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L46,46",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L46,46",
    id: "Line",
    transform: "translate(23.000000, 23.000000) rotate(-270.000000) translate(-23.000000, -23.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContacts);
export default __webpack_public_path__ + "static/media/icon-contacts.d25c91bebe38b1617bf2e12fdd18dd2f.svg";
export { ForwardRef as ReactComponent };